import BaseServices from "./BaseServices";

const EmbroideryServices = {
    //#region Khung thêu
    // Lấy danh sách khung thêu theo paging cho màn quản lý hoop.
    GetHoops: async (paging) => {
        return BaseServices.Post(`/api/Embroidery/get-hoops`, paging);
    },
    // Lấy chi tiết một khung thêu để bind modal chỉnh sửa.
    GetHoopById: async (id) => {
        return BaseServices.Get(`/api/Embroidery/get-hoop/${id}`);
    },
    // Tạo mới hoặc cập nhật cấu hình khung thêu.
    CreateUpdateHoop: async (model) => {
        return BaseServices.Post(`/api/Embroidery/create-update-hoop`, model);
    },
    // Xóa mềm khung thêu theo id.
    DeleteHoop: async (id) => {
        return BaseServices.Post(`/api/Embroidery/delete-hoop/${id}`);
    },
    // Lấy dropdown khung thêu active, có thể lọc theo loại hoop.
    GetHoopDropdown: async (hoopType = 0) => {
        return BaseServices.Get(`/api/Embroidery/get-hoop-dropdown?hoopType=${hoopType}`);
    },
    //#endregion

    //#region Máy thêu
    GetMachines: async (paging) => {
        return BaseServices.Post(`/api/Embroidery/get-machines`, paging);
    },
    GetMachineById: async (id) => {
        return BaseServices.Get(`/api/Embroidery/get-machine/${id}`);
    },
    CreateUpdateMachine: async (model) => {
        return BaseServices.Post(`/api/Embroidery/create-update-machine`, model);
    },
    DeleteMachine: async (id) => {
        return BaseServices.Post(`/api/Embroidery/delete-machine/${id}`);
    },
    //#endregion

    //#region Kim - needle bar
    GetNeedleBarsByMachineId: async (machineId) => {
        return BaseServices.Get(`/api/Embroidery/get-needle-bars/${machineId}`);
    },
    SaveNeedleBars: async (machineId, needleBars) => {
        return BaseServices.Post(`/api/Embroidery/save-needle-bars/${machineId}`, needleBars);
    },
    GetNeedleColorGroups: async () => {
        return BaseServices.Get(`/api/Embroidery/get-needle-color-groups`);
    },
    //#endregion

    //#region Họa tiết thêu (pattern)
    GetPatterns: async (paging) => {
        return BaseServices.Post(`/api/Embroidery/get-patterns`, paging);
    },
    GetPatternById: async (id) => {
        return BaseServices.Get(`/api/Embroidery/get-pattern/${id}`);
    },
    CreateUpdatePattern: async (model) => {
        return BaseServices.Post(`/api/Embroidery/create-update-pattern`, model);
    },
    DeletePattern: async (id) => {
        return BaseServices.Post(`/api/Embroidery/delete-pattern/${id}`);
    },
    //#endregion

    //#region Font chữ thêu
    // Lấy danh sách bộ font thêu theo paging cho màn quản lý font.
    GetFonts: async (paging) => {
        return BaseServices.Post(`/api/Embroidery/get-fonts`, paging);
    },
    // Lấy chi tiết bộ font thêu gồm danh sách size và glyph đã upload.
    GetFontById: async (id) => {
        return BaseServices.Get(`/api/Embroidery/get-font/${id}`);
    },
    // Tạo mới hoặc cập nhật bộ font thêu cùng size/glyph đi kèm.
    CreateUpdateFont: async (model) => {
        return BaseServices.Post(`/api/Embroidery/create-update-font`, model);
    },
    // Xóa mềm bộ font thêu theo id.
    DeleteFont: async (id) => {
        return BaseServices.Post(`/api/Embroidery/delete-font/${id}`);
    },
    //#endregion
};

export default EmbroideryServices;
